module.exports = __webpack_public_path__ + "src/img/empty.2d7c325e.svg";